define(function(require) {
    var CC = require('CC');
    var BaseCollection = require('models/Base.collection');
    var TokenModel = require('models/user/Tokens.model');
    var TokensCollection = BaseCollection.extend({
        model: TokenModel,

        url: function() {
            return CC.apiUrl + '/users/tokens';
        }
    });
    return TokensCollection;
});
